import { render } from "./Logs.vue?vue&type=template&id=0c799adc"
import script from "./Logs.vue?vue&type=script&lang=js"
export * from "./Logs.vue?vue&type=script&lang=js"
script.render = render

export default script